module.exports = __webpack_public_path__ + "static/gallery14-b60535a49ecb2bf1de77060d27681814.jpg";